import { z } from 'zod';

export const DrawingViewportSchema = z.object({
  id: z.string().uuid(),
  project_id: z.string().uuid(),
  page_id: z.string().uuid(),
  name: z.string(),
  description: z.string().nullable(),
  bounds: z.tuple([z.number(), z.number(), z.number(), z.number()]),
  viewport_type: z.string(),
  created_by: z.string().uuid().nullable(),
  created_at: z.string().datetime(),
  updated_at: z.string().datetime(),
});

export const CreateDrawingViewportSchema = z.object({
  page_id: z.string().uuid(),
  name: z.string().min(1, 'Name is required'),
  description: z.string().nullable().optional(),
  bounds: z.tuple([z.number(), z.number(), z.number(), z.number()]),
  viewport_type: z.string().default('section_cut'),
});

export const UpdateDrawingViewportSchema = CreateDrawingViewportSchema.partial();

export type DrawingViewport = z.infer<typeof DrawingViewportSchema>;
export type CreateDrawingViewport = z.infer<typeof CreateDrawingViewportSchema>;
export type UpdateDrawingViewport = z.infer<typeof UpdateDrawingViewportSchema>;
